import React from 'react'
import { LCSLHPTIGroupedHeader, LCSLHPTIHeader, LCSLHPTIRow } from '../hooks/useLCSLHPTITablaValor';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { OperacionLCSLHPTITablaValorFields } from '../types/fields';

interface LCLSHPTITablaValoresProps {
    headers: LCSLHPTIGroupedHeader[];
    rows: LCSLHPTIRow[];
}

const LCLSHPTITablaValores = ({headers, rows}: LCLSHPTITablaValoresProps) => {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
                >
                  Instrumento
                </TableCell>
                {headers.map((group) => (
                  <TableCell
                    key={group.agrupacion}
                    align="center"
                    colSpan={group.columnas.length}
                    sx={{ backgroundColor: 'grey.100', fontWeight: 'bold', borderRight: 1, borderColor: 'divider' }}
                  >
                    {group.agrupacion}
                  </TableCell>
                ))}
              </TableRow>

              <TableRow>
                <TableCell sx={{ borderRight: 1, borderColor: 'divider', backgroundColor: 'grey.50' }} />
                {headers.flatMap(group =>
                  group.columnas.map(col => (
                    <TableCell
                      key={col.codOperacionTipo}
                      align="center"
                      sx={{ fontWeight: 'medium', fontSize: '0.75rem', borderRight: 1, borderColor: 'divider', minWidth: 100 }}
                    >
                      {col.descOperacionTipo}
                    </TableCell>
                  ))
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.rowKey}
                  hover>
                  <TableCell
                    sx={{ fontWeight: 'bold', backgroundColor: 'grey.50', borderRight: 1, borderColor: 'divider' }}
                  >
                    {row.descInstrumento}
                  </TableCell>
                  {headers.flatMap(group =>
                    group.columnas.map(col => {
                      const celda = row.celdas[col.codOperacionTipo];

                      return (
                        <TableCell
                          key={`${row.codInstrumento}-${col.codOperacionTipo}`}
                          align="center"
                          sx={{ borderRight: 1, borderColor: 'divider' }}
                        >
                          <Typography variant="body2">
                            {celda[OperacionLCSLHPTITablaValorFields.Valor]}
                          </Typography>
                        </TableCell>
                      );
                    })
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  )
}

export default LCLSHPTITablaValores